import { render, staticRenderFns } from "./QRCodeScanner.vue?vue&type=template&id=80a976d0&"
import script from "./QRCodeScanner.vue?vue&type=script&lang=js&"
export * from "./QRCodeScanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports